import { Link } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="bg-white fixed top-0 w-full z-40 shadow-sm">
        <div className="container mx-auto flex items-center justify-between py-4 px-6">
          <div className="flex items-center gap-0">
            <img src={logo} alt="logo" className="w-12 h-12 object-contain" />
            <span className="text-l font-bold text-blue-500">Gizimon MBG</span>
          </div>
          
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8 text-gray-700 text-lg">
            <Link to="/" className="hover:text-blue-600">
              Home
            </Link>
            <Link to="/unit" className="hover:text-blue-600">
              Unit MBG
            </Link>
            <Link to="/edukasi" className="hover:text-blue-600">
              Education
            </Link>
            <Link to="/school" className="hover:text-blue-600">
              Sekolah
            </Link>
            <Link to="/detail" className="hover:text-blue-600">
              Gizi
            </Link>
          </nav>

          {/* Desktop Buttons (Updated to Link) */}
          <div className="hidden md:flex items-center gap-3">
            <Link 
              to="/login" 
              className="bg-gradient-to-r from-indigo-500 to-blue-500 text-white px-5 py-2 rounded-full font-semibold hover:opacity-90"
            >
              Login
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden px-3 py-2 rounded-lg border border-gray-300"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <span className="text-2xl font-bold">✕</span>
            ) : (
              <span className="text-2xl font-bold">☰</span>
            )}
          </button>
        </div>

        {/* Mobile Dropdown */}
        {open && (
          <div className="md:hidden bg-white shadow-md px-6 pb-5 pt-2 space-y-4 text-gray-700 text-lg">
            <Link to="/" className="block hover:text-blue-600" onClick={() => setOpen(false)}>
              Home
            </Link>
            <Link to="/unit" className="block hover:text-blue-600" onClick={() => setOpen(false)}>
              Unit MBG
            </Link>
            <Link to="/edukasi" className="block hover:text-blue-600" onClick={() => setOpen(false)}>
              Education
            </Link>
            <Link to="/school" className="block hover:text-blue-600" onClick={() => setOpen(false)}>
              Sekolah
            </Link>

            {/* Mobile Buttons (Updated to Link) */}
            <div className="pt-3 space-y-3">
              <Link 
                to="/login"
                onClick={() => setOpen(false)} 
                className="block w-full text-center bg-gradient-to-r from-indigo-500 to-blue-500 text-white px-5 py-2 rounded-full font-semibold hover:opacity-90"
              >
                Login
              </Link>
            </div>
          </div>
        )}
      </header>

      <div className="pt-28"></div>
    </>
  );
}